import { render, staticRenderFns } from "./receipt-processor.vue?vue&type=template&id=bf21f6bc&scoped=true"
import script from "./receipt-processor.vue?vue&type=script&lang=js"
export * from "./receipt-processor.vue?vue&type=script&lang=js"
import style0 from "./receipt-processor.vue?vue&type=style&index=0&id=bf21f6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf21f6bc",
  null
  
)

export default component.exports